import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { Error } from "@mui/icons-material";

export function showMinInvertersPowerAlert(functionOnclose?: Function, functionOnConfirmation?: Function) {
  confirmationDialog.setup({
    onlyConfirm: true,
    content: [
      'O inversor selecionado e respectiva quantidade, não atende a quantidade total de módulos do projeto.',
      <br/>,
      <br/>,
      'Sugestões:',
      <ul>
        <li>Altere a quantidade de módulos; ou</li>
        <li>Altere o modelo e/ou quantidade do inversor;</li>
      </ul>
    ],
    size: '440px',
    title: "Atenção!",
    yesText: 'OK',
    propagateWhenConfirm: true,
    subtitle:<span>Quantidade <strong>mínima</strong> de inversores</span>,
    onClose: () => {
      if(functionOnclose) functionOnclose();
      confirmationDialog.close();
    },
    onConfirmation: () => {
      if(functionOnConfirmation) functionOnConfirmation();
    },
    headerIcon: <Error style={{ color: '#CC8F00' }} />, 
  })
  confirmationDialog.open();
}